import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IGetServiceContract } from 'sales-types-common';

interface ServiceContractState {
  serviceContract: IGetServiceContract | null;
  serviceContractLoading: boolean;
}

const initialState: ServiceContractState = {
  serviceContract: null,
  serviceContractLoading: false,
};

const serviceContractSlice = createSlice({
  name: 'serviceContract',
  initialState,
  reducers: {
    setServiceContract: (state, action: PayloadAction<IGetServiceContract>) => {
      state.serviceContract = action.payload;
    },
    setServiceContractLoading: (state, action: PayloadAction<boolean>) => {
      state.serviceContractLoading = action.payload;
    },
  },
});

export const { setServiceContract, setServiceContractLoading } = serviceContractSlice.actions;
export default serviceContractSlice.reducer;
